import React, { useEffect, useMemo } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import * as types from "../redux/actions/CMSData";
import { getActiveLang, withLang } from "../utils/language";

function About() {
  const selectedLanguage = getActiveLang();
  const dispatch = useDispatch();
  const CMSData = useSelector((state) => state.cmsdatadetail.cmsdatadetail);
  const AboutData = CMSData?.about_us || {};

  useEffect(() => {
    if (!CMSData || Object.keys(CMSData).length === 0) {
      dispatch({ type: types.FETCH_CMSDATA_REQUEST });
    }
  }, [CMSData, dispatch]);

  const content = useMemo(() => {
    const suffix = selectedLanguage === "ori" ? "_ori" : "_en";
    return {
      title: AboutData[`title${suffix}`],
      description: AboutData[`description${suffix}`],
      otherDetails: AboutData[`other_details${suffix}`],
    };
  }, [selectedLanguage, AboutData]);

  const isOriya = selectedLanguage === "ori";

  return (
    <>
      <div className="innerPages">
        <Container>
          <Row>
            <Col sm={12}>
              <h2>
                {isOriya ? "ଆମ " : "About "}
                <span>{isOriya ? "ବିଷୟରେ" : "Us"}</span>
              </h2>
              <ul>
                <li>
                  <Link to={withLang("/")}>{isOriya ? "ହୋମ୍" : "Home"}</Link>
                </li>
                <li>/</li>
                <li>
                  <strong>{isOriya ? "ଆମ ବିଷୟରେ" : "About Us"}</strong>
                </li>
              </ul>
            </Col>
          </Row>
        </Container>
      </div>

      <div className="aboutSection innerBg">
        <Container>
          <Row className="d-flex align-items-center">
            {AboutData?.logo && (
              <Col lg={5} sm={12}>
                <img
                  src={AboutData.logo}
                  alt="Krushak_Odisha_aboutUs"
                  className="img-fluid"
                />
              </Col>
            )}
            <Col lg={AboutData?.logo ? 7 : 12} sm={12}>
              <h2 dangerouslySetInnerHTML={{ __html: content.title }} />
              <strong
                className="text-justify"
                dangerouslySetInnerHTML={{ __html: content.description }}
              />
            </Col>
            <Col sm={12} className="mt-3">
              <span
                className="text-justify"
                dangerouslySetInnerHTML={{ __html: content.otherDetails }}
              />
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default About;
